import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: 253.7,
    marginTop: 22,
    marginRight: 23.8,
    marginBottom: 1.5,
    paddingTop: 9,
    paddingBottom: 10.4,
    borderRadius: 10,
    boxShadow: '0 3 6 0 rgba(0, 0, 0, 0.16)',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.only('sm')]: {
      marginRight: 5,
      marginLeft: 5,
    },
    [theme.breakpoints.only('xs')]: {
      width: '100%',
      height: 'auto',
    },
  },
  containerContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  containerBody: {
    paddingLeft: 11.6,
    paddingRight: 11.6,
  },
  wrapperImage: {
    width: '100%',
    height: 'auto',
    aspectRatio: '1.619', // 233.3 / 144.1
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  wrapperProfileImage: {
    [theme.breakpoints.up('sm')]: {
      marginTop: 17.2,
      aspectRatio: 'initial',
    },
  },
  image: {
    [theme.breakpoints.only('xs')]: {
      width: '100% !important',
      height: '100% !important',
      objectFit: 'contain',
    },
  },
  profileImage: {
    width: 90.1,
    height: 90.1,
    borderRadius: 45.05,
  },
  resourceImage: {
    width: 233.3,
    height: 144.1,
    borderRadius: 6,
  },
  containerTitle: {
    marginTop: 10,
  },
  title: {
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: 1.88,
    letterSpacing: 0.16,
    color: '#202a2f',
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  titleProfile: {
    marginTop: 4.4,
    textAlign: 'center',
  },
  titleResource: {
    marginTop: 6.6,
    textAlign: 'left',
  },
  containerDescriptionProfile: {
    paddingLeft: 9.1,
    paddingRight: 9.1,
    marginBottom: 60.6,
  },
  containerDescriptionResource: {
    paddingLeft: 2.1,
    paddingRight: 2.1,
    marginBottom: 24,
  },
  description: {
    opacity: 0.5,
    fontFamily: 'Roboto',
    fontSize: 14,
    letterSpacing: 0.14,
    color: '#202a2f',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  descriptionProfile: {
    marginTop: 6.2,
    textAlign: 'center',
    lineHeight: 1.15,
  },
  descriptionResource: {
    marginTop: 8.4,
    textAlign: 'left',
    lineHeight: 1.05,
  },
  containerFooterButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  containerLeftIcons: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 12.5,
  },
  personIcon: {
    width: 13,
    height: 23.1,
    opacity: 0.5,
  },
  peopleIcon: {
    width: 24.4,
    height: 20.5,
  },
  infoIcon: {
    width: 20.9,
    height: 20.9,
    opacity: 0.5,
  },
  tag: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 26,
    paddingLeft: 8,
    paddingRight: 12,
    borderRadius: 6,
    backgroundColor: '#95989a',
    marginLeft: 5.8,
  },
  titleTag: {
    fontFamily: 'Roboto',
    fontSize: 16,
    textAlign: 'left',
    color: '#fff',
  },
  flagButton: {
    padding: 0,
    backgroundColor: 'transparent',
    width: 14.9,
    height: 19.8,
    marginTop: 5,
    marginRight: 12.6,
  },
  flagButtonProfile: {
    marginTop: 0,
    marginRight: 14.6,
  },
  flagIcon: {
    width: 14.9,
    height: 19.8,
  },
}));
